import ExpenseCategoryFormConfig from "./form";
import GenericForm from "../GenericForm";
import { ExpenseCategoryFormData } from "@/formTypes/ExpenseCategoryDataType";
import { ExpenseCategoryApi, ExpenseCategoryDataType } from "@/api/ExpenseCategoryApi";

type ExpenseCategoryFormProps = {
  id?: string;
  formId: string,
  saveRedirectUrl: string
}

const ExpenseCategoryForm = (props: ExpenseCategoryFormProps) => {

  return (
    <GenericForm<ExpenseCategoryFormData, ExpenseCategoryDataType>
      id={props.id}
      formId={props.formId}
      saveRedirectUrl={props.saveRedirectUrl}
      formConfig={ExpenseCategoryFormConfig}
      getById={(...arg) => ExpenseCategoryApi.get(...arg)}
      createFn={(...arg) => ExpenseCategoryApi.create(...arg)}
      updateFn={(...arg) => ExpenseCategoryApi.update(...arg)}
      successMessage="La Categoria de Gasto ha sido almacenada correctamente"
      errorMessage="No fue posible almacenar la información de la Categoria de Gasto"
    />
  )
}

export default ExpenseCategoryForm;